import { createContext, useContext } from "react";

// Pozwala dolnej nawigacji (NavTestPage) przełączać overlay statystyk
// wewnątrz SolveProblem BEZ realnej nawigacji na osobną trasę — dzięki temu
// SolveProblem się nie odmontowuje i bieżące zadanie nie przeskakuje na kolejne.
// null = brak sesji z overlayem → nawigacja działa klasycznie (NavLink).
const SessionStatsContext = createContext(null);

export const SessionStatsProvider = SessionStatsContext.Provider;
export const useSessionStatsNav = () => useContext(SessionStatsContext);
